module.exports = __webpack_public_path__ + "static/7-07b2ca0b89e173005d365a67d861fafe.pdf";